import axios from 'axios';
import { API } from '../config';
import { kirill } from './kirill';
import lugatA from './lugat-a';
import lugatB from './lugat-b';
import lugatC from './lugat-c';

// Panel tili: o'zbek (lotin), o'zbek (kirill), rus.
//
// QANDAY ISHLAYDI: kodda matn o'zbekcha (lotin) yoziladi va tr() ga
// o'raladi — tr('Saqlash'). O'sha o'zbekcha matn lug'atda KALIT:
//   • uz       → matnning o'zi
//   • uz-Cyrl  → avtomatik kirillga o'giriladi (lug'at kerak emas)
//   • ru       → lugat-*.js dagi tarjima; topilmasa o'zbekcha qoladi
//
// {nom} — o'zgaruvchan qism: tr('{n} ta yozuv', { n: 5 }). Qiymat
// (ism, son) o'girilmaydi — faqat matnning o'zi.
//
// Til almashganda sahifa qayta yuklanadi: shunda modul darajasidagi
// matnlar ham yangi tilda qayta hisoblanadi va hech qayerda aralash til
// qolmaydi.
//
// YANGI MATN QO'SHSANGIZ: `node scripts/til-sinov.js` tarjimasi yo'q
// matnlarni ko'rsatadi.

export const TILLAR = [
  { kod: 'uz', nom: 'O\'zbekcha' },
  { kod: 'uz-Cyrl', nom: 'Ўзбекча' },
  { kod: 'ru', nom: 'Русский' },
];

const KALIT = 'til';
const LUGAT = { ...lugatA, ...lugatB, ...lugatC };

const oqi = () => {
  try {
    const t = localStorage.getItem(KALIT);
    return TILLAR.some((x) => x.kod === t) ? t : null;
  } catch {
    return null;
  }
};

// Bir marta o'qiladi: tr() har sahifada yuzlab marta chaqiriladi.
const JORIY = oqi() || 'uz';

export const joriyTil = () => JORIY;

// Foydalanuvchi o'zi tanlaganmi (yoki hali sukut bo'yicha)?
export const tilTanlanganmi = () => oqi() !== null;

const qoy = (matn, qiymatlar) => (qiymatlar
  ? matn.replace(/\{(\w+)\}/g, (butun, k) => (qiymatlar[k] ?? butun))
  : matn);

export const tr = (matn, qiymatlar) => {
  if (typeof matn !== 'string') return matn;
  let natija = matn;
  if (JORIY === 'uz-Cyrl') natija = kirill(matn);
  else if (JORIY === 'ru') natija = LUGAT[matn] ?? matn;
  return qoy(natija, qiymatlar);
};

// Tilni almashtirish. Kirgan bo'lsa serverga ham saqlanadi — push
// bildirishnomalar shu tilda kelishi va boshqa qurilmada ham shu til
// ochilishi uchun.
export const tilniOzgartir = async (kod, { qaytaYukla = true } = {}) => {
  try { localStorage.setItem(KALIT, kod); } catch { /* bloklangan */ }
  const token = localStorage.getItem('token');
  if (token) {
    await axios.put(`${API}/users/til`, { til: kod }, { headers: { authorization: token } })
      .catch(() => {});
  }
  if (qaytaYukla) window.location.reload();
};

// Serverdan kelgan (login javobidagi) tilni qabul qilish.
export const serverTiliniQabulQil = (kod) => {
  if (!kod || kod === JORIY || !TILLAR.some((x) => x.kod === kod)) return false;
  try { localStorage.setItem(KALIT, kod); } catch { /* bloklangan */ }
  return true;
};

// <html lang> — ekran o'quvchi dasturlar va brauzer tarjimoni uchun.
if (typeof document !== 'undefined') {
  document.documentElement.lang = JORIY === 'uz-Cyrl' ? 'uz-Cyrl' : JORIY;
}
